import React from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { createStyles, spacing } from "../../../styles/theme";
import SpecsNumberField from "./SpecsNumberField";

const styles = createStyles({
  rangePaper: {
    p: spacing.groupingDesktop,
  },
  rangeFieldsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: spacing.smallDesktop,
    alignItems: "flex-start",
  },
  rangeNumberField: {
    flex: "1 1 120px",
    minWidth: 120,
  },
  rangeCheckbox: {
    m: 0,
    minHeight: 40,
    whiteSpace: "nowrap",
  },
});

type JsonObject = Record<string, unknown>;

type PricingRangeRowProps = {
  entry: JsonObject;
  index: number;
  debugPath?: string;
  clickToEdit?: boolean;
  onChange: (nextValue: JsonObject) => void;
  onRemove: () => void;
};

export default function PricingRangeRow({
  entry,
  index,
  debugPath,
  clickToEdit,
  onChange,
  onRemove,
}: PricingRangeRowProps) {
  return (
    <Paper variant="outlined" sx={styles.rangePaper}>
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="subtitle2">Range {index + 1}</Typography>
          <Box sx={{ flex: 1 }} />
          <Button
            variant="outlined"
            size="small"
            color="inherit"
            onClick={onRemove}
          >
            Remove
          </Button>
        </Stack>
        <Box sx={styles.rangeFieldsRow}>
          <Box sx={styles.rangeNumberField}>
            <SpecsNumberField
              label="Qty"
              value={typeof entry.qty === "number" ? entry.qty : null}
              allowNull
              debugPath={debugPath ? `${debugPath}.qty` : undefined}
              clickToEdit={clickToEdit}
              onChange={(qty) =>
                onChange({
                  ...entry,
                  ...(qty === null ? {} : { qty }),
                })
              }
            />
          </Box>
          <Box sx={styles.rangeNumberField}>
            <SpecsNumberField
              label="Price"
              value={typeof entry.price === "number" ? entry.price : null}
              allowNull
              debugPath={debugPath ? `${debugPath}.price` : undefined}
              clickToEdit={clickToEdit}
              onChange={(price) =>
                onChange({
                  ...entry,
                  ...(price === null ? {} : { price }),
                })
              }
            />
          </Box>
          <Box sx={styles.rangeNumberField}>
            <SpecsNumberField
              label="Shipping"
              value={typeof entry.shipping === "number" ? entry.shipping : null}
              allowNull
              debugPath={debugPath ? `${debugPath}.shipping` : undefined}
              clickToEdit={clickToEdit}
              onChange={(shipping) =>
                onChange({
                  ...entry,
                  ...(shipping === null ? {} : { shipping }),
                })
              }
            />
          </Box>
          <FormControlLabel
            sx={styles.rangeCheckbox}
            control={
              <Checkbox
                checked={Boolean(entry.distributorOnly)}
                onChange={(_, checked) =>
                  onChange({
                    ...entry,
                    ...(checked ? { distributorOnly: true } : {}),
                  })
                }
              />
            }
            label="Distributor only"
          />
          <FormControlLabel
            sx={styles.rangeCheckbox}
            control={
              <Checkbox
                checked={Boolean(entry.adminOnly)}
                onChange={(_, checked) =>
                  onChange({
                    ...entry,
                    ...(checked ? { adminOnly: true } : {}),
                  })
                }
              />
            }
            label="Admin only"
          />
        </Box>
      </Stack>
    </Paper>
  );
}
